<template>
  <BaseNoticeItem :button-text="buttonText" :button-url="buttonUrl">
    <template #head>
      <strong v-if="!hasDeterminationResult">
        <span v-if="complianceData.determination === 'ir35'">
          Please wait for IR35 determination
        </span>
        <span v-else>Please wait for Worker Classification</span>
      </strong>
      <strong v-else-if="askForBusinessEntity">Please update your business setup</strong>
    </template>
    <template #icon>
      <DeterminationLogo
        class="tw-float-right"
        :determination="complianceData.determination"
        :size="50"
      />
    </template>
    <template #body>
      <span v-if="!hasDeterminationResult">
        {{ hire.company.name }} has not yet completed the Worker Classification to determine your
        worker status on this contract.
      </span>
      <span v-else-if="complianceData.determination === 'ir35' && askForBusinessEntity">
        You need a Limited company setup for this contract.
        <span>
          {{
            $t('Please :link before accepting the job.', {
              link: $t('update your account details'),
            })
          }}
        </span>
      </span>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import gql from 'graphql-tag'
import { computed, defineProps } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import DeterminationLogo from '@/components/compliances/Determinations/DeterminationLogo.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
})

const hasDeterminationResult = computed(
  () =>
    props.complianceData.determinationResult !== null &&
    !props.complianceData.determinationResultPendingClassificationApproval,
)

const askForBusinessEntity = computed(
  () => hasDeterminationResult.value && !props.complianceData.hasCorrectBusinessEntity,
)

const buttonText = computed(() => {
  if (askForBusinessEntity.value) {
    return $t('Update')
  }
  return null
})

const buttonUrl = computed(() => {
  if (askForBusinessEntity.value) {
    const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
      redirect_uri: redirectUri,
    })
    return `${path}#business-entity`
  }
  return null
})
</script>

<script>
export const fragments = {
  hire: gql`
    fragment AcceptHireDeterminationAlertHire on Hire {
      company {
        name
      }
    }
  `,
}
</script>
